import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { UserFilter, UsersService, userGetFullname } from '@prodcard/core'
import { Ref, ref, watch } from 'vue'
import VAutocompleteServer from './VAutocompleteServer.vue'
import { TextFieldDensity, createCtx, handleError } from '../helpers'
import { isEqual } from 'lodash'

interface UserForSelect {
  fullname: string
  id: string
}

interface Props {
  usersService: UsersService
  additionalFilterData?: UserFilter
  modelValue?: string
  label?: string
  loading?: boolean
  disabled?: boolean
  density?: TextFieldDensity
}

const count = 15


export default /*#__PURE__*/_defineComponent({
  __name: 'VUserSelect',
  props: {
    usersService: {},
    additionalFilterData: {},
    modelValue: {},
    label: { default: 'Ответственное лицо' },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    density: {}
  },
  setup(__props: any) {

const props = __props;



const users: Ref<UserForSelect[]> = ref([])

const select = ref()
const loadDefaultUser = ref(false)
const isLoadMoreItems = ref(true)
const from = ref(0)
const total = ref(0)
const updateUserList = (paging: { from: number; count: number }, filter?: UserFilter, replace = false) => {
  handleError(async () => {
    try {
      const response = await props.usersService.findAll(createCtx(), {
        paging,
        filter,
      })

      const resultList = response.items.map(user => ({ fullname: userGetFullname(user), id: user.id }))
      if (replace) {
        users.value = resultList
      } else {
        users.value.push(...resultList)
      }

      isLoadMoreItems.value = users.value.length < response.total
      from.value += paging.count
      if (total.value !== response.total) total.value = response.total
    } catch (e) {
      users.value = []
      from.value = 0
      total.value = 0
      isLoadMoreItems.value = false
      throw e
    }
  })
}

const updateSearchValue = (val: string) => {
  from.value = 0
  updateUserList({ from: from.value, count: count }, { search: val, ...props.additionalFilterData }, true)
}

const findDefaultUserById = (id: string) => {
  handleError(async () => {
    const user = await props.usersService.findById(createCtx(), id)
    if (user) {
      select.value = { fullname: userGetFullname(user), id: user.id }
    }
  }, loadDefaultUser)
}

watch(
  () => props.modelValue,
  val => {
    if (!val && select.value) {
      select.value = undefined
      from.value = 0
      updateUserList({ from: from.value, count: count }, props.additionalFilterData, true)
      return
    }
    if (select.value || !val) return

    findDefaultUserById(val)
  },
  { immediate: true },
)

watch(
  () => props.additionalFilterData,
  (newVal, oldVal) => {
    if (!isEqual(newVal, oldVal)) {
      from.value = 0
      updateUserList({ from: from.value, count: count }, newVal, true)
    }
  },
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VAutocompleteServer, {
    modelValue: select.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((select).value = $event)),
      _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:model-value', $event?.id)))
    ],
    "item-title": "fullname",
    items: users.value,
    isLoadMoreItems: isLoadMoreItems.value,
    label: _ctx.label,
    loading: loadDefaultUser.value || _ctx.loading,
    disabled: loadDefaultUser.value || _ctx.disabled,
    density: _ctx.density,
    "onUpdate:searchValue": updateSearchValue,
    onLoadMore: _cache[2] || (_cache[2] = search => updateUserList({ from: from.value, count: count }, { search, ..._ctx.additionalFilterData }))
  }, null, 8, ["modelValue", "items", "isLoadMoreItems", "label", "loading", "disabled", "density"]))
}
}

})